import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
      isScrolled ? 'bg-white border-b border-gray-300 shadow-sm' : 'bg-white border-b border-gray-200'
    }`}>
      <div className="max-w-[1400px] mx-auto px-[7.6923%] h-20 flex items-center justify-between md:justify-center relative">
        {/* Desktop Navigation - Left Side */}
        <nav className="hidden md:flex items-center gap-8 absolute left-[7.6923%]">
          <button 
            onClick={() => scrollToSection('home')}
            className="text-gray-600 hover:text-black text-lg font-normal transition-colors duration-300"
          >
            Home
          </button>
          <button 
            onClick={() => scrollToSection('about')}
            className="text-gray-600 hover:text-black text-lg font-normal transition-colors duration-300"
          >
            About
          </button>
          <button 
            onClick={() => scrollToSection('clients')}
            className="text-gray-600 hover:text-black text-lg font-normal transition-colors duration-300"
          >
            Our Clients
          </button>
        </nav>

        {/* Logo - Centered */}
        <div className="flex items-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_lynqnext-landing/artifacts/z485gwgx_Final%20Logo.jpg" 
            alt="LYNQnext Consulting" 
            className="h-12 object-contain cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          />
        </div>

        {/* Desktop Navigation - Right Side (Contact Us) */}
        <nav className="hidden md:flex items-center absolute right-[7.6923%]">
          <button 
            onClick={() => scrollToSection('contact')}
            className="text-gray-600 hover:text-black text-lg font-normal transition-colors duration-300 border border-gray-300 px-6 py-2 hover:border-gray-500"
          >
            Contact Us
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-black p-2 absolute right-4"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 px-[7.6923%] py-6">
          <nav className="flex flex-col gap-4">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-gray-600 hover:text-black text-lg font-normal transition-colors duration-300 text-left"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-600 hover:text-black text-lg font-normal transition-colors duration-300 text-left"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('clients')}
              className="text-gray-600 hover:text-black text-lg font-normal transition-colors duration-300 text-left"
            >
              Our Clients
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-600 hover:text-black text-lg font-normal transition-colors duration-300 border border-gray-300 px-6 py-2 hover:border-gray-500 mt-2 text-left"
            >
              Contact Us
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
